<script>
    import VcModal from "@/components/Form/Modal"


    export default {
        props: ['analiseProp'],
        name: "ModalObsInterna",
        components: {
            VcModal
        },
        data() {
            return {
                analise: {},
                isOpen: false,
            }
        },
        watch: {
            analiseProp: {
                handler(novaAnalise) {
                    this.analise = novaAnalise;
                }
            }
        },
        computed: {
        },
        methods: {
            closeModal() {
                this.isOpen = false;
                this.analise = {};
                this.$emit('close')
            },

            salvarObservacao() {
                this.$http.post("api/analises/atualizarInfoAnalise/", this.analise).then(async response => {
                    if(response.data.erro == '0') {
                        return window.swal(
                            "Sucesso",
                            "Observação salva com sucesso.<br><br>",
                            "success"
                        );
                    } else {
                        return window.swal(
                            "Atenção",
                            "Houve um problema ao salvar a observação.<br><br>" +
                            response.data.mensagem,
                            "error"
                        );
                    }
                });
                this.closeModal();
            },


            modalObservacao() {
                this.isOpen = true;
                this.analise = this.analiseProp;
            }
        },
        mounted() {
            this.$set(this, 'analise', this.analiseProp)
        }
    }
</script>

<template>
    <div class="row" style="padding: 0px 15px;">
        <vc-modal v-if="isOpen" @close="closeModal" :isOpen="isOpen">
            <div slot="header">Observação interna</div>
            <div slot="body">
                <div class="form-group">
                    <label for="observacao">Observação</label>
                    <textarea
                        v-model="analise.obs_interna"
                        class="form-control"
                        id="obs_interna"
                        rows="10"></textarea>
                </div>
            </div>
            <div slot="footer">
                <button @click="salvarObservacao" class="btn btn-primary">Salvar</button>
                <button @click="closeModal" class="btn btn-secondary">Fechar</button>
            </div>
        </vc-modal>


        <button
            class="btn btn-info btn-block"
            style="background-color: gray; color: white;"
            @click="modalObservacao()"
            title="Observações">
            <i class="fa fa-pen"></i> Observações internas
        </button>
    </div>
</template>